var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKongs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KONGS",
    transform: "translate(370.553 -278.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12271",
    "data-name": "Rectangle 12271",
    width: 2.329,
    height: 28.082,
    transform: "translate(-368.224 306.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12272",
    "data-name": "Rectangle 12272",
    width: 2.329,
    height: 9.78,
    transform: "translate(-370.553 299.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12273",
    "data-name": "Rectangle 12273",
    width: 2.329,
    height: 2.37,
    transform: "translate(-368.224 299.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12274",
    "data-name": "Rectangle 12274",
    width: 2.329,
    height: 4.807,
    transform: "translate(-368.224 292.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12275",
    "data-name": "Rectangle 12275",
    width: 2.329,
    height: 2.474,
    transform: "translate(-365.895 289.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12276",
    "data-name": "Rectangle 12276",
    width: 19.151,
    height: 2.474,
    transform: "translate(-363.565 287.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12277",
    "data-name": "Rectangle 12277",
    width: 2.329,
    height: 4.807,
    transform: "translate(-342.085 292.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12278",
    "data-name": "Rectangle 12278",
    width: 2.329,
    height: 13.372,
    transform: "translate(-342.085 306.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12279",
    "data-name": "Rectangle 12279",
    width: 2.329,
    height: 2.474,
    transform: "translate(-344.414 289.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12280",
    "data-name": "Rectangle 12280",
    width: 2.329,
    height: 2.474,
    transform: "translate(-344.414 320.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12281",
    "data-name": "Rectangle 12281",
    width: 2.329,
    height: 2.474,
    transform: "translate(-358.705 320.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12282",
    "data-name": "Rectangle 12282",
    width: 2.329,
    height: 2.474,
    transform: "translate(-353.99 307.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12283",
    "data-name": "Rectangle 12283",
    width: 2.329,
    height: 2.474,
    transform: "translate(-349.206 307.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12284",
    "data-name": "Rectangle 12284",
    width: 11.961,
    height: 2.474,
    transform: "translate(-356.375 322.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12285",
    "data-name": "Rectangle 12285",
    width: 11.961,
    height: 2.474,
    transform: "translate(-356.375 315.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12286",
    "data-name": "Rectangle 12286",
    width: 2.329,
    height: 4.807,
    transform: "translate(-361.034 315.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12287",
    "data-name": "Rectangle 12287",
    width: 2.329,
    height: 9.631,
    transform: "translate(-356.375 325.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64988",
    "data-name": "Path 64988",
    d: "M-356.067,390.313v2.412h4.57v7.364h25.1v-9.776Zm16.563,7.3h-9.373v-4.89h9.373Zm10.74,0h-7.982v-4.89h7.982Z",
    transform: "translate(-12.157 -93.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64989",
    "data-name": "Path 64989",
    d: "M-298.363,278.639v2.5h-2.353v-2.5h-5.929v2.5h-2.38v-2.5h-2.329v7.385h1.1v2.5H-297.2v-2.5h1.165v-7.385Zm-3.444,3.659h-1.227v1.269h1.227v2.4h-1.227v-2.4h-1.277v2.4h-1.227v-4.8h1.227V282.3h1.277v-1.129h1.227Z",
    transform: "translate(-49.679)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKongs);
export default __webpack_public_path__ + "static/media/kongs.3f1d31bfeac4a55550f6581a8478e646.svg";
export { ForwardRef as ReactComponent };